import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Dropdown } from 'react-bootstrap';
import { handleAPIError } from 'utils/handleErrors';
import ReceiptsCSV from '../../../../components/reactCsv/ReceiptsCSV';
// api
import { getDocuments } from '../../../../api/Api-user';
// components
import LoadingPulse from '../../../../components/loading/LoadingPulse';
import RowBilling from './card/RowBilling';
import CardBilling from './card/CardBilling';
import Paginate from '../../../../components/Paginate';

const Receipts = () => {
  const [receipts, setReceipts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  // paginate
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [changePage, setChangePage] = useState(1); // para la peticion
  const [changeItemsNum, setChangeItemsNum] = useState(10); // para la peticion
  const [message, setMessage] = useState('');

  // - Use references to do scroll Up
  const startRef = useRef(null);
  const settingPage = (limit) => {
    setChangeItemsNum(limit);
    setChangePage(1);
  };

  const handlerGetReceipts = async () => {
    if (receipts) {
      setIsLoading(true);
    }
    try {
      const response = await getDocuments('receipts', changePage, changeItemsNum);
      // console.log('recibos:', response);
      if (response.data !== undefined) {
        setReceipts(response.data);
        setCurrentPage(response.current_page); // para actualizar la vista
        setPageSize(response.page_size); // para actualizar la vista
        setTotalPages(response.total_pages);
        if (startRef.current) {
          startRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (response.data.length === 0) {
          setMessage('No tienes recibos registrados.');
        }
      } else if (response.error) {
        setReceipts(receipts || []);
        setTotalPages(0);
        handleAPIError(response);
      }
    } catch (error) {
      setReceipts(receipts || []);
      handleAPIError(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    handlerGetReceipts();
  }, [changePage, changeItemsNum]);
  // console.log('Get receipts res -->', receipts)

  return (
    <>
      {isLoading && <LoadingPulse />}
      {receipts?.length === 0 && message ? (
        <div className="pt-5 mt-5">
          <h3 className="text-center mt-5 pt-5">
            {message}
            <img alt="box" src="/img/animation/doc.webp" style={{ width: '50px', height: '50px' }} />{' '}
          </h3>
        </div>
      ) : (
        <div ref={startRef} id="cardContainer">
          <Row className="g-0">
            <Col className="mb-3 text-end bg-infox">
              {/* Excel Buttons  */}
              {receipts?.length > 0 && <ReceiptsCSV receipts={receipts} />}
              {/* Dropdown  */}

              <Dropdown align={{ xs: 'end' }} className={`d-inline-block ms-2 ${receipts?.length < 10 && 'd-none'}`}>
                <Dropdown.Toggle variant="foreground-alternate" className="shadow sw-15">
                  {`${pageSize} Recibos`}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow dropdown-menu-end">
                  <Dropdown.Item className={`${pageSize === 10 && 'd-none'}`} onClick={() => settingPage(10)}>
                    10 Recibos
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 20 && 'd-none'}`} onClick={() => settingPage(20)}>
                    20 Recibos
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 50 && 'd-none'}`} onClick={() => settingPage(50)}>
                    50 Recibos
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 100 && 'd-none'}`} onClick={() => settingPage(100)}>
                    100 Recibos
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className={`${receipts?.length < 2 && 'd-none'} mt-3 text-muted`}>{`Página ${currentPage}`}</div>
            </Col>
          </Row>
          {/* List Header Start */}
          <RowBilling />
          {/* List Header End */}
          {/* List Items Start */}
          {receipts?.map((receipt, index) => (
            <CardBilling data={receipt} doc="receipt" key={index} />
          ))}
          {/* List Items End */}
          {/* Pagination Start */}
          <div className={`d-flex flex-column justify-content-center align-items-center mt-5 mx-auto ${totalPages < 2 && 'd-none'}`}>
            <Paginate currentPage={currentPage} totalPages={totalPages} setCurrentPage={setChangePage} />
          </div>
          {/* Pagination End */}
        </div>
      )}
    </>
  );
};

export default Receipts;
